import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import Head from 'next/head';
import { connect } from 'react-redux';
import forOwn from 'lodash/forOwn';
import { wrapper } from '~/store';
import nextI18nextConfig from '~/../next-i18next.config';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import Layout from '~/containers/Layout';
import NewContainer from '~/containers/NewPage';
import { loadNewData } from '~/containers/NewPage/actions';
import config, { keyConfig } from '~/config';
import HrefLangs from '~/components/HrefLangs';

@connect((state) => ({
  photos: state.newPage.result.photos,
  location: state.newPage.result.query,
  totalItem: state.newPage.result.totalItem,
  totalPage: state.newPage.result.totalPage,
}))
@defaultPage()
class NewDesign extends React.Component {
  // static async getInitialProps({
  //   query,
  //   store,
  //   isAuthenticated,
  //   profile,
  //   api,
  //   clientIp,
  // }) {
  //   const language = store.getState().language.currentLanguage;
  //   store.dispatch(
  //     loadNewData({
  //       eventType: 'new',
  //       lang: language,
  //       page: query.page,
  //       per_page: query.per_page,
  //       clientIp,
  //       count_all: true,
  //     }),
  //   );

  //   return {
  //     query,
  //   };
  // }

  renderAsPath = (query, route_new_page) => {
    query = Object.assign({}, query);
    const url = `/${route_new_page}/`;
    let params = '';
    let isFirstIndex = true;
    forOwn(query, (query, key) => {
      if (Array.isArray(query)) {
        query = query.map(({ query }) => query).toString();
      }

      if (query && key !== 'is_tag' && key !== 'lng' && key !== 'token') {
        if (isFirstIndex) {
          params = params.concat(`?${key}=${query}`);
          isFirstIndex = false;
        } else {
          params = params.concat(`&${key}=${query}`);
        }
      }
    });
    return url + params;
  };

  render() {
    const {
      t,
      lng,
      photos,
      location,
      totalPage,
      totalItem,
      query,
    } = this.props;

    const canonical = `${config.getSiteURL()}/${keyConfig.get(
      'route_new_page',
    )}?pattern_id=${query.pattern_id}`;

    const hrefPrev = `${canonical}?page=${parseInt(location.page) - 1}`;
    const hrefNext = `${canonical}?page=${parseInt(location.page) + 1}`;
    const data = photos && photos.length ? photos[0] : {};
    return (
      <Layout>
        <Head>
          <title>{t(config.getPrefixContent('new_page_seo'))}</title>
          {parseInt(location.page) === 1 ? (
            ''
          ) : (
            <link rel="prev" href={hrefPrev} />
          )}
          {parseInt(location.page) >= totalPage ? (
            ''
          ) : (
            <link rel="next" href={hrefNext} />
          )}
          <meta
            id="meta-keywords"
            name="keywords"
            content={t(
              config.getPrefixContent('meta_description_new_page_seo'),
            )}
          />
          <meta
            id="meta-description"
            name="description"
            content={t(config.getPrefixContent('meta_keywords_new_page_seo'), {
              total: totalItem,
            })}
          />
          <HrefLangs
            pagePath={this.renderAsPath(query, keyConfig.get('route_new_page'))}
            lng={lng}
          />
          {/* <meta property="og:image" content={data.path || ''} /> */}
          <meta
            property="og:image"
            content={`${
              config.staticPrefix
            }/static/assets/image/logo/${config.renderImagePage()}`}
          />
          <meta
            property="og:title"
            content={t(config.getPrefixContent('new_page_seo'), {
              total: totalItem,
            })}
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:description"
            content={t(
              config.getPrefixContent('meta_description_new_page_seo'),
            )}
          />
          <meta property="og:url" content={canonical} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={canonical} />
          <meta
            name="twitter:title"
            content={t(config.getPrefixContent('new_page_seo'))}
          />
          <meta
            name="twitter:description"
            content={t(
              config.getPrefixContent('meta_description_new_page_seo'),
              { total: totalItem },
            )}
          />
          <meta name="twitter:image" content={data.path || ''} />
          <meta name="twitter:site" content={`${config.getSiteURL()}`} />
          <meta name="twitter:creator" content={`@${config.getName()}`} />
        </Head>
        <NewContainer t={t} lng={lng} />
      </Layout>
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      query,
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    // const language = store.getState().language.currentLanguage;
    const language = currentLanguage;

    store.dispatch(
      loadNewData({
        eventType: 'new',
        lang: language,
        page: query.page,
        per_page: query.per_page,
        clientIp,
        count_all: true,
      }),
    );

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default NewDesign;
